const Form089TC = {
    stepName: {
        importantNotes: "重要提示",
        basicInfo: "津貼申請",
        useOfTheGrant: "上學年津貼運用概況",
        schoolInfo: "學校資料",
        confirmation: "確認",
    },
    label: {
        statementHeader: "注意",
        statement: "本人已閱讀、明白及同意上述條款及細則",
        applicationForTheGrantOption: {
            applicationForTheGrant1:
                "本校有意申請學生活動支援津貼，並會遵照津貼運用指引妥善運用撥款，以支援校內有經濟需要的學生參與學校舉辦或認可的全方位學習活動。",
            applicationForTheGrant2: "本校無意申請學生活動支援津貼。原因如下：",
        },

        noOption: {
            supportStudents:
                "本校會運用其他資源資助有經濟需要的學生參與全方位學習活動。",
            others: "其他原因：",
        },
        reason: "原因",
        schoolTypeOption: {
            primary: "小學",
            secondary: "中學",
            PrimaryCumSecondary: "小學暨中學",
            special: "特殊學校 ",
        },

        basicInfo: "津貼申請",
        header: "學生活動支援津貼（{{schoolyear}}學年） 申請表格 ",
        header1: " （請於{{deadline}}或之前將填妥的申請表格交回教育局）",
        applicationForTheGrant: "一）申請意願  ",
        toolTip: "（請在適用的方格內加上「√」號）",
        useOfTheGrant: "上學年津貼運用概況",
        title: "二）上學年（{{previousSchoolYear}}）津貼運用概況",
        toolTip1: "請提供{{previousSchoolYear}}學年預算總開支。",
        expenditure: "{{previousSchoolYear}}學年預算總開支",

        table: {
            category: "學生類別",
            expectedNumberOfStudentBeneficiaries: "預算受惠學生人數",
            expectedSubsidisedAmount: "預算資助金額",
        },

        specify1: "（上限為{{previousSchoolYear}}學年津貼金額的25%）",
        total: "總計",
        schoolInfo: "學校資料",
        comfirmation: "確認",
        schoolName: "學校名稱",
        schoolType: "學校類別",
        schoolCode: "學校編號（6位數）",
        nameOfTeacherInCharge: "負責教師姓名",
        post: "負責教師職位",
        emailAddressOfTeacherInCharge: "負責教師電郵",
        ContactPhone: "聯絡電話號碼",
        nameOfSupervisor: "校監姓名",
        annotation: "請註明",
        specify: "（6位數字編號）",
        specify2: "請註明",
        applyGrant: "上學年（{{previousSchoolYear}}）有否申請津貼",
        applyGrantOption: {
            yes: "有",
            no: "否",
        },
    },
    importantNotes: {
        p1_1: "個人資料收集聲明",
        p1_2: "教育局會利用本表格所載的個人資料，作以下其中一種或多種用途︰",

        p1_a: "辦理與聘用有關的事宜；",
        p1_b: "處理發放薪金津貼，以及計算公積金的供款和贈款；",
        p1_c: "進行核數工作；",
        p1_d: "進行研究及統計資料，以便規劃教育服務；",
        p1_e: "處理有關教育專業人員發展的事宜；",
        p1_f: "執行《教育條例》、《教育規例》及附屬《補助/津貼學校公積金規則》(第279章)。",

        p2: "申請人必須在本表格上填寫個人資料。申請人如不提供這些資料，申請的處理工作及結果或會受影響。",
        p3: "本表格所蒐集的個人資料，或會向其他獲授權的政府決策局/部門/機構披露作上述用途。",
        p4: "根據《個人資料(私隱)條例》，第18和22條及附表1保障資料第6原則的規定，你有權要求查閱及改正你的個人資料。要求查閱的權利，包括要求提供本表格所載個人資料的副本，但須繳付費用。",
        p5: "如欲查詢有關本表格所蒐集的個人資料，包括要求查閱及改正資料事宜，需以書面方式向教育局提出。",
    },
    category: {
        category1: "綜合社會保障援助",
        category2: "學校書簿津貼計劃－全額津貼",
        category3: "校本評定有經濟需要",
        total: "總計",
    },
    errorMsg: {
        schoolName: "請輸入一個有效的學校名稱",
        schoolCode: "請輸入一個有效的學校編號",
        teacherName: "請輸入一個有效的負責教師姓名",
        post: "請輸入一個有效的職位",
        email: "請輸入一個有效的負責教師電郵",
        phoneNo: "請輸入一個有效的聯絡電話號碼",
        otherInput: "請輸入一個有效的原因",
        E0001: "請輸入一個6位數字編號",
        // E0002: "Please input a valid phone number  (cannot be an English character)",
        // E0003: "Please input a valid email address of Teacher-in-charge",
        E0002: "(1) 和 (2) 不能同時選擇。",
        E0003: "(2a) 和 (2b) 不能同時選擇。",
        E0004: "如果你选择了其他，請輸入一個有效的原因。",
        E0005: "請輸入一個有效的數字",
        // E0006: "Please input a valid name ",
        // E0008: "Please input a valid position ",
        // E0001: "此項必須為整數",
        // E0002: "請輸入一個有效的電話號碼",
        // E0003: "請輸入一個有效的負責教師電郵",
        // E0004: "（i）和（ii）不能被同時選擇",
        // E0005: "（iii）和（iv）不能被同時選擇",
        // E0006: "如果選擇了其他，請詳細說明",
        // E0007: "請輸入正確的名稱",
        // E0008: "請輸入正確的位置",
        // E0009: "此項最小值為1",
        E0010: "學校編號必須為最少6位數",
        E0011: "學校編號必須為最多6位數",
        E0012: "聯絡電話號碼必須為8位數",
        E0013: "預算總開支應等於總預算資助金額",
    },
};
export default Form089TC;
